import {
  GridColDef,
  GridRenderCellParams,
  GridRowId,
} from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { ClientType, InsurerType } from '../../../../types';
import { GridColumnFields } from '../../bill-grid-components/bill-management-types';
import {
  getBillAmountColumn,
  getBillIdColumn,
  getBillingTypeColumn,
  getClientColumn,
  getDateOfServiceColumn,
  getInsurerColumn,
  getMoreDetailsAction,
  getNetsuiteIdColumn,
  getPartnershipColumn,
  getSourceIdColumn,
  getSubmissionColumn,
  getSubmissionIdColumn,
  getSubmissionStatusColumn,
  getTransactionIdColumn,
  getUserIdColumn,
} from '../../bill-grid-components/shared-columns';

interface UseSubmissionColumnsProps {
  clientsData: ClientType[];
  insurersData: Omit<InsurerType, 'eligibilityRef' | 'memberIdRequired'>[];
  moreDetails: (id: GridRowId) => () => void;
}

export const useSubmissionColumns = ({
  clientsData,
  insurersData,
  moreDetails,
}: UseSubmissionColumnsProps): GridColDef[] =>
  useMemo(
    () => [
      getSubmissionIdColumn(),
      getBillIdColumn(),
      getBillAmountColumn(),
      getDateOfServiceColumn(),
      getUserIdColumn(),
      getSourceIdColumn(),
      getClientColumn(clientsData),
      getInsurerColumn(insurersData),
      getPartnershipColumn(),
      getBillingTypeColumn(),
      getNetsuiteIdColumn(),
      getTransactionIdColumn(),
      getSubmissionStatusColumn(),
      getSubmissionColumn(),
      {
        field: GridColumnFields.ACTIONS,
        headerName: 'Actions',
        type: 'actions',
        align: 'right',
        width: 100,
        getActions: (params: GridRenderCellParams): React.ReactElement[] => [
          getMoreDetailsAction(params.id, moreDetails),
        ],
      },
    ],
    [clientsData, insurersData, moreDetails],
  );
